var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagCookIslands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8365 24.8365 32 16 32C7.1635 32 0 24.8365 0 16C0 16.0038 16 0.00175 16 0C24.8365 0 32 7.1635 32 16Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9572 16.0001H16C16 15.9857 16 15.9717 16 15.9573C15.9858 15.9716 15.9715 15.9858 15.9572 16.0001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8.34781C16 5.5325 16 3.68781 16 0H15.9973C7.16194 0.0015 0 7.16431 0 16H8.34781V11.2993L13.0485 16H15.9572C15.9715 15.9858 15.9858 15.9715 16.0001 15.9572C16.0001 14.8793 16.0001 13.9174 16.0001 13.0486L11.2992 8.34781H16Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09469 2.08691C5.59225 3.51185 3.51181 5.59223 2.08694 8.09466V16H6.26087V6.26098V6.26085H16C16 4.94441 16 3.69029 16 2.08691H8.09469Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 14.0325L10.3153 8.3479H8.34781V8.34803L15.9999 16H16C16 16 16 14.6433 16 14.0325Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5652 16L21.8613 16.911H22.8191L22.0443 17.474L22.3403 18.3851L21.5652 17.822L20.7903 18.3851L21.0863 17.474L20.3114 16.911H21.2692L21.5652 16Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6301 17.63L18.4835 18.0648L19.1609 17.3875L19.011 18.3336L19.8645 18.7685L18.9184 18.9182L18.7686 19.8645L18.3336 19.0109L17.3876 19.1608L18.065 18.4835L17.6301 17.63Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 21.5653L16.911 21.2693L16.9111 20.3115L17.474 21.0863L18.3851 20.7903L17.822 21.5653L18.3851 22.3403L17.474 22.0443L16.9111 22.8192V21.8614L16 21.5653Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6301 25.5003L18.0649 24.6468L17.3876 23.9696L18.3337 24.1194L18.7686 23.2659L18.9184 24.212L19.8645 24.3617L19.011 24.7967L19.1609 25.7429L18.4835 25.0654L17.6301 25.5003Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5652 27.1304L21.2692 26.2194H20.3113L21.0863 25.6564L20.7903 24.7454L21.5652 25.3084L22.3403 24.7454L22.0443 25.6564L22.8191 26.2194H21.8613L21.5652 27.1304Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5001 25.5003L24.6466 25.0656L23.9693 25.7429L24.1191 24.7967L23.2656 24.3619L24.2118 24.212L24.3616 23.2659L24.7964 24.1194L25.7426 23.9696L25.0651 24.6469L25.5001 25.5003Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1302 21.5653L26.2191 21.8614V22.8192L25.6561 22.0443L24.7451 22.3403L25.3082 21.5653L24.7451 20.7903L25.6561 21.0863L26.2191 20.3115V21.2693L27.1302 21.5653Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5001 17.6302L25.0653 18.4836L25.7426 19.1609L24.7964 19.0111L24.3616 19.8646L24.2118 18.9184L23.2656 18.7686L24.1191 18.3338L23.9693 17.3877L24.6466 18.0649L25.5001 17.6302Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagCookIslands);
export default __webpack_public_path__ + "static/media/flag_cook_islands.9887b1fea240ab9f82f99da893affb7d.svg";
export { ForwardRef as ReactComponent };